import { render, staticRenderFns } from "./keluarga.vue?vue&type=template&id=1c5673b8&"
import script from "./keluarga.vue?vue&type=script&lang=js&"
export * from "./keluarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports